/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Lib dependencies
import {
  RouterProvider as NativeRouterProvider,
  createRouter,
} from '@tanstack/react-router';
import { useEffect, useState } from 'react';
import * as Sentry from "@sentry/react";

// Providers
import { queryClient } from '@/providers/QueryClientProvider';

// Stores
import usePhysiomKineStore from '@/stores/physiomKine';

// Others
import { routeTree } from '@/routeTree.gen';

// Components
import ErrorComponent from '@/components/ErrorComponent/ErrorComponent';
import SentryFallback from '@/components/ErrorComponent/SentryFallback';

/* -------------------------------------------------------------------------- */
/*                                 Provider                                   */
/* -------------------------------------------------------------------------- */

export const router = createRouter({
  routeTree,
  context: {
    queryClient,
    isAuthenticated: undefined!,
    user: null,
  },
  defaultErrorComponent: ErrorComponent,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}


export default function RouterProvider() {
  const [hydrated, setHydrated] = useState(false);
  const { isAuthenticated, user } = usePhysiomKineStore();

  useEffect(() => {
    setHydrated(true); // Zustand store will be hydrated when this component mounts
  }, []);

  if (!hydrated) {
    return <div>Loading...</div>; // Don't render anything until the store has finished hydrating
  }

  return (
    <Sentry.ErrorBoundary fallback={SentryFallback}>
      <NativeRouterProvider
        router={router}
        context={{ isAuthenticated, user }}
      />
    </Sentry.ErrorBoundary>
  );
}
